import { isNil, filter, complement } from 'ramda';

export default filter(complement(isNil));
